import { NgModule } from '@angular/core';
import { angularProvidersBuilder } from '@harmony/angular';

import { AlbumsDefaultProvider, AlbumsProvider } from './albums.provider';
import { GetTeamAlbumsInteractor } from './domain/interactors/get-team-albums.interactor';
import { UpdateAlbumInteractor } from './domain/interactors/update-album.interactor';
import { AuthProvider } from '../auth/auth.provider';
import { FirebaseToken } from '../../app/core/firebase.module';
import { Functions } from 'firebase/functions';
import { RemoveAlbumInteractor } from './domain/interactors/remove-album.interactor';
import { VerifyAlbumInteractor } from './domain/interactors/verify-album.interactor';
import { CreateAlbumInteractor } from './domain/interactors/create-album.interactor';
import { Firestore } from 'firebase/firestore';
import { CommonProvider } from '../common/common.provider';
import { TeamProvider } from '../team/team.provider';
import { GetAlbumByIdInteractor } from './domain/interactors/get-album-by-id.interactor';
import { UpdateAlbumDataInteractor } from './domain/interactors/update-album-data.interactor';
import { AssignAlbumsInteractor } from './domain/interactors/assign-albums.interactor';
import { TroubleshootAlbumInteractor } from './domain/interactors/troubleshoot-album.interactor';

@NgModule({
  providers: angularProvidersBuilder({
    provide: AlbumsProvider,
    deps: [
      AuthProvider,
      CommonProvider,
      FirebaseToken.Firestore,
      FirebaseToken.Functions,
      TeamProvider,
    ],
    useFactory: (
      authProvider: AuthProvider,
      commonProvider: CommonProvider,
      firestore: Firestore,
      functions: Functions,
      teamProvider: TeamProvider,
    ) =>
      new AlbumsDefaultProvider(authProvider, commonProvider, firestore, functions, teamProvider),
  })
    .add(AssignAlbumsInteractor, (p) => p.provideAssignAlbums())
    .add(CreateAlbumInteractor, (p) => p.provideCreateAlbum())
    .add(GetAlbumByIdInteractor, (p) => p.provideGetAlbumById())
    .add(GetTeamAlbumsInteractor, (p) => p.provideGetTeamAlbums())
    .add(RemoveAlbumInteractor, (p) => p.provideRemoveAlbum())
    .add(TroubleshootAlbumInteractor, (p) => p.provideTroubleshootAlbum())
    .add(UpdateAlbumInteractor, (p) => p.provideUpdateAlbum())
    .add(UpdateAlbumDataInteractor, (p) => p.provideUpdateAlbumData())
    .add(VerifyAlbumInteractor, (p) => p.provideVerifyAlbum())
    .build(),
})
export class AlbumsProviderModule {}
